module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-normal.b4c6b22d.png";